import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PackageFilterEntity } from '../../domain/entities/PackageFilterEntity'

export class PackageFilterModel extends PackageFilterEntity {
  userId?: string
  serviceId?: number
  regionId?: number
  constructor(dataDto: PackageFilterEntity) {
    super()
    mapEntityProperties<PackageFilterModel>(this, dataDto, {
      exclude: ['user', 'service', 'region'],
      map: {
        userId: dataDto.user?.id,
        serviceId: dataDto.service?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
